import type { DependencyList } from "react";
import { useEffect } from "react";

export function useImmediateEffect(
  effect: () => void,
  dependencies: DependencyList,
): void {
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, dependencies);
}
